<!-- 充值 -->
<template>
  <div>
    <el-dialog title="" :close-on-click-modal="false" top="5vh" center :visible.sync="visible" width="622px" @open="handleOpen" :before-close="handleClose" class="common-dialog-class">
      <div class="dialog-member-title">
        <div class="dialog-member-name">
          快付账户余额<span>{{$store.state.orgFastPayBalance}} 元</span>
        </div>
        <div class="dialog-close" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="recharge-content">
        <div class="bank-info">
          <h3>请将款项转入以下银行账号</h3>
          <div class="bank-info-item">
            <span class="label">银行账号</span>
            <span class="value">{{ bankInfo.accountNumber }}</span>
            <el-button type="text" @click="copyBankAccount" size="mini">
              <i class="el-icon-document-copy"></i>
            </el-button>
          </div>
          <div class="bank-info-item">
            <span class="label">银行名称</span>
            <span class="value">{{ bankInfo.bankName }}</span>
            <el-button type="text" @click="copyBankName" size="mini">
              <i class="el-icon-document-copy"></i>
            </el-button>
          </div>
          <div class="bank-info-item">
            <span class="label">账户名</span>
            <span class="value">{{ bankInfo.accountName }}</span>
            <el-button type="text" @click="copyAccountName" size="mini">
              <i class="el-icon-document-copy"></i>
            </el-button>
          </div>
          <div class="bank-info-item">
            <span class="label">备注</span>
            <span class="value">{{ bankInfo.mark }}</span>
            <el-button type="text" @click="markName" size="mini">
              <i class="el-icon-document-copy"></i>
            </el-button>
          </div>
        </div>
        
        <div class="transfer-info">
          <h3>转账信息</h3>
          <div class="info-item">
            <span class="label">充值账号</span>
            <span class="value">{{orgAuthInfo.orgName}} <template v-if="orgAuthInfo.phone">({{orgAuthInfo.phone}})</template></span>
          </div>
          <el-form :model="form" :rules="rules" ref="form">
            <div class="form-item">
              <span class="label"><em style="color: red;">*</em>充值金额</span>
              <el-form-item prop="rechargeAmount">
                <el-input v-model.number="form.rechargeAmount" placeholder="请输入充值金额" type="number" min="0.01"></el-input>
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="label"><em style="color: red;">*</em>转账说明</span>
              <el-form-item prop="transferDesc">
                <el-input v-model="form.transferDesc" placeholder="请输入转账账户名或手机号后6位的标识信息"></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="tips">
            <el-popover
              placement="right"
              width="250"
              trigger="hover"
            >
              <img :src="require('@/assets/images/orderCenter/transout.png')" alt="转账标识信息示例" style="width: 100%;" />
              <p slot="reference" class="popover-trigger" style="cursor: pointer; color: #3888e9;display:inline-block;">哪些信息可以作为转账标识信息？</p>
            </el-popover>
          </div>
        </div>
        
        <div class="transfer-proof">
          <h3>转账凭证</h3>
          <upload @uploading="uploadHandle" :auto-upload="true"
              :image-url="proofUrl" :drag="true" :this-type="'avater'"
              @input="handleUploadInput" @deleteDoc="handleDeleteDoc">
          </upload>
        </div>
        
        <div class="submit-btn">
          <el-button type="primary" @click="submitRecharge" :loading="loading" :disabled="!canSubmit">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSessionStorage } from "@/utils/auth";
import { getorgpackages, createrechargeorder, getrechargeorder } from "@/api/orderCenter";
import { orgfastpayrecharge, getorgvisabankcard } from "@/api/finance";
import UQRCode from 'uqrcodejs';
import { EventBus } from '@/utils/eventBus.js';
import alyoss from '@/utils/alyoss';
import upload from '@/components/upload.vue'
export default {
  data() {
    return {
      payType: 7, // 支付方式：微信7|支付宝8
      payActive: {},
      ticketsList: [],
      qrLoading: false,
      qrData: '在线免费生成二维码工具',//数据
      canvas: null,
      qrTime: '',
      qrInfo: {
        payParameters: ''
      },
      qrcodeObj: {}, // 二维码配置
      form: {
        rechargeAmount: '',
        transferDesc: ''
      },
      bankInfo: {
        accountNumber: '',
        bankName: '',
        accountName: '',
        mark:''
      },
      rules: {
        rechargeAmount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '充值金额必须大于0', trigger: 'blur' }
        ],
        transferDesc: [
          { required: true, message: '请输入转账说明', trigger: 'blur' }
        ]
      },
      fileList: [],
      proofUrl: '',
      loading: false,
      previewVisible: false,
      previewList: [],
      orgAuthInfo:{
        orgName:'',
        phone:''
      }
    }
  },
  components: {
      upload
  },
  computed: {
    canSubmit() {
      return this.form.rechargeAmount && this.form.transferDesc;
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String | Number,
      default: '',
    },
  },
  methods: {



    /** 图片上传成功回调 */
    uploadImgBack(val) {
        console.log(val)
        this.avatar = val
    },
    /** 处理上传组件的输入事件 */
    handleUploadInput(url) {
        if (url) {
            this.proofUrl = url;
            this.fileList = [{ name: '转账凭证', url: url }];
        }
    },
    /** 处理删除凭证事件 */
    handleDeleteDoc() {
        this.fileList = [];
        this.proofUrl = '';
    },
    /** 移除上传的凭证 */
    removeProof() {
        this.proofUrl = '';
        this.fileList = [];
    },
    /** 处理上传中事件 */
    uploadHandle(loading) {
        // 可以在这里处理上传中的逻辑，例如显示加载状态
        console.log('上传中:', loading);
    },
    handleOpen() {
      this.payType = 7;
      this.form.rechargeAmount = '';
      this.form.transferDesc = '';
      this.fileList = [];
      this.proofUrl = '';
      // 查询快付账户收款账号
      this.getBankCardInfo();
    },
    // 查询快付账户收款账号
    getBankCardInfo() {
      getorgvisabankcard().then(res => {
        if (res.code == 1 && res.data) {
          let bankInfo = JSON.parse(res.data.json);
          this.bankInfo = {
            accountNumber: bankInfo.cardNumber,
            bankName: bankInfo.bankName,
            accountName: bankInfo.CardName,
            mark:bankInfo.mark || ''
          };

          // 尝试从vue_kuaimavisa_orgAuthInfo缓存中获取orgName和phone
          const vueKuaimavisaOrgAuthInfo = getSessionStorage("orgAuthInfo");
          if (vueKuaimavisaOrgAuthInfo) {
            if (vueKuaimavisaOrgAuthInfo.orgName) {
              this.orgAuthInfo.orgName = vueKuaimavisaOrgAuthInfo.orgName;
            }
            if (vueKuaimavisaOrgAuthInfo.phone) {
              this.orgAuthInfo.phone = vueKuaimavisaOrgAuthInfo.phone;
            }
          }
          
        }
      }).catch(() => {
        // 接口调用失败时使用默认值
        console.log('获取银行账号失败，使用默认值');
      });
    },
    handleClose() {
      this.payActive = {}
      this.payType = 0
      if (this.qrTime) { // 判断清除
        clearInterval(this.qrTime)
        this.qrTime = null
      }
      this.$emit('close')
    },
    clickTickets(item) {
      this.payActive = item
      if(this.payType) {
        this.submitRecharge()
      }
    },
    setPayActive(val) {
      if (!this.payActive || !this.payActive.id) {
        return this.$message.error("请选择快币充值金额")
      }
      this.payType = val
      this.submitRecharge()
    },
    getInfo() {
      getorgpackages().then(res => {
        if (res.code == 1) {
          this.ticketsList = res.data;
          if(this.ticketsList.length) {
            this.clickTickets( this.ticketsList[0])
          }
          
        }
      })
    },
    async uploadProof(file) {
      try {
        let alyossData = await alyoss(file.file);
        this.proofUrl = alyossData;
        this.fileList = [{ name: file.file.name, url: alyossData }];
      } catch (error) {
        this.$message.error('上传失败，请重试');
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      if (fileList.length === 0) {
        this.proofUrl = '';
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    handlePreview(file) {
      this.previewList = [file.url];
      this.previewVisible = true;
    },
    copyBankAccount() {
      this.copyToClipboard(this.bankInfo.accountNumber);
    },
    copyBankName() {
      this.copyToClipboard(this.bankInfo.bankName);
    },
    copyAccountName() {
      this.copyToClipboard(this.bankInfo.accountName);
    },
    markName() {
      this.copyToClipboard(this.bankInfo.mark);
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    submitRecharge() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          
          // 这里需要调用快币充值接口，将充值金额、转账说明和凭证URL传递给后端
          orgfastpayrecharge({
            rechargeAmount: this.form.rechargeAmount,
            remark: this.form.transferDesc,
            url: this.proofUrl
          }).then(res => {
            this.loading = false;
            if (res.code == 1) {
              this.$message.success('充值申请提交成功，请等待审核');
              this.handleClose();
            } else {
              this.$message.error(res.msg || '充值申请提交失败');
            }
          }).catch(() => {
            this.loading = false;
            this.$message.error('网络错误，请重试');
          });
        } else {
          // if (!this.proofUrl) {
          //   this.$message.error('请上传转账凭证');
          // }
          // return false;
        }
      });
    },
    getrechargeorderFn(id) {
      getrechargeorder({
        orderId: id,
      }).then(res => {
        if (res.data.status == 1) {
          if (this.qrTime) { // 判断清除
            clearInterval(this.qrTime)
            this.qrTime = null
          }
          this.$message({
            message: '充值成功',
            type: 'success'
          });
          this.$emit('success')
          this.handleClose()
          EventBus.$emit('refreshOrgBalance');
          EventBus.$emit('refreshOrgTotal');
        }
      })
    },

    sureClick(imgStc) {
      // if (this.qrData.length <= 0) {
      //     return false
      // }
      // 获取uQRCode实例
      var qr = new UQRCode();
      // 设置二维码内容
      qr.data = imgStc;
      // 设置二维码大小，必须与canvas设置的宽高一致
      qr.size = 90;
      qr.margin = 5;
      // 调用制作二维码方法
      qr.make();
      // 获取canvas元素
      this.canvas = document.getElementById("qrcode");
      // 获取canvas上下文
      var canvasContext = this.canvas.getContext("2d");
      // 设置uQRCode实例的canvas上下文
      qr.canvasContext = canvasContext;
      // 调用绘制方法将二维码图案绘制到canvas上
      qr.drawCanvas();
    },
    downLoadImage() {
      var a = document.createElement("a");
      a.href = this.canvas.toDataURL();
    //   a.download = '六月初工具站-二维码生成';
      a.click();
    },
  },
  destroyed() {
    if (this.qrTime) { // 判断清除
      clearInterval(this.qrTime)
      this.qrTime = null
    }
  }
}
</script>

<style lang="scss" scoped>
$themeColor: #3888e9;

::v-deep .common-dialog-class {
  background: none !important;
  border-radius: 12px;

  .el-dialog {
    background: none;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    // width: 761px;

    // height: 285px;
    background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
    border-radius: 12px;
    box-sizing: border-box;
    overflow: hidden;
  }
}
.common-dialog-foot-class {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;

  .pageck-btn {
    width: 122px;
    margin: 0 16px;
  }
}
.common-dialog-class {
  .dialog-member-title {
    align-items: inherit;
    margin-top: 0;
  }
  .dialog-member-name {
    font-weight: 500;
    width: 499px;
    height: 53px;
    background: #ffffff;
    color: #333333;
    border-radius: 8px 8px 8px 8px;
    display: inline-flex;
    align-items: center;
    padding: 0 12px;
    margin-bottom: 24px;
    span {
      font-size: 20px;
      font-weight: bold;
      margin-left: 20px;
    }
  }
  .tips1 {
    color: #333333;
    font-size: 20px;
  }
  .tips2 {
    color: #999999;
    font-size: 14px;
    margin: 8px 0 20px;
  }
  .dialog-contenter {
    margin-top: 12px;
    .themeColor {
      color: $themeColor;
    }
    .card-desc {
      display: inline-flex;
      .recharge {
        margin-left: 25px;
        color: $themeColor;
      }
    }
    .card-box {
      margin-top: 20px;
      display: flex;
      .card-item + .card-item {
        margin-left: 20px;
      }
      .card-item {
        width: 125px;
        height: 92px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e0e0e0;
        transition: transform 0.3s;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        color: #333333;

        .card-item-name {
          font-size: 20px;
        }
        .card-item-ticket {
          font-size: 14px;
        }
      }
      .active {
        border: 1px solid $themeColor;
        overflow: hidden;
        .active-check {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 22px;
          height: 22px;
          background-color: $themeColor;

          display: flex;
          .el-icon-check {
            margin: auto;
            font-size: 16px;
            transform: rotate(0deg);
            color: #fff;
          }
        }
      }
    }
  }
  .recharge-box {
    margin-top: 40px;
    padding: 16px 9px;
    color: #ffffff;
    background: linear-gradient(90deg, #0c0b0a 0%, #4c4c4c 100%);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .recharge-left {
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      height: 80px;
      .recharge-left-top {
        display: inline-flex;
        align-items: flex-end;
        span {
          margin-left: 16px;
          font-size: 10px;
        }
      }
      .recharge-left-content {
        color: #ffe6ca;
        font-size: 30px;
        span {
          font-size: 10px;
        }
      }
    }
    .recharge-right {
      display: flex;
      .recharge-type {
        margin-right: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        .recharge-right-item + .recharge-right-item {
          margin-top: 5px;
        }
        .recharge-right-item {
          display: inline-flex;
          align-items: center;
          justify-content: center;

          cursor: pointer;
          width: 115px;
          height: 30px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #696969;

          img {
            width: 14px;
            height: 14px;
            margin-right: 8px;
          }

          span {
            font-size: 14px;
          }
        }
        .recharge-right-item-active {
          position: relative;
          border: 1px solid #ffe6ca;
          .recharge-right-item-check {
            background: #ffe6ca;
            position: absolute;
            bottom: 0;
            right: 0;
            width: 14px;
            height: 14px;

            display: flex;
            .el-icon-check {
              margin: auto;
              font-size: 10px;
              transform: rotate(0deg);
              color: #fff;
            }
          }
        }
      }

      .qrcode-box {
        width: 90px;
        height: 90px;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #707070;
        .tips {
            color: #d5d5d5;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            height: 100%;
            font-size: 12px;
        }
      }
    }
  }
  .recharge-content {
    .bank-info {
      background: #fff;
      padding: 16px;
      border-radius: 8px 8px 0 0;
      h3 {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
        color: #333;
      }
      .bank-info-item {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        .label {
          width: 80px;
          font-size: 14px;
          color: #666;
        }
        .value {
          flex: 1;
          font-size: 14px;
          color: #333;
          text-align: right;
          padding: 4px;
        }
      }
    }
    .transfer-info {
      background: #fff;
      padding: 16px 16px 0;
      border-radius:  0 0 8px 8px;
      h3 {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
        color: #333;
      }
      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .label {
          width: 80px;
          font-size: 14px;
          color: #666;
        }
        .value {
          flex: 1;
          font-size: 14px;
          color: #333;
        }
      }
      .el-form-item {
        margin-bottom: 0;
        width: calc(100% - 100px);
      }
      .form-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;  
        .label {
          width: 80px;
          font-size: 14px;
          color: #666;
        }
        .el-input {
          flex: 1;
          ::v-deep .el-form-item__content {
            line-height: 28px;
          }
          ::v-deep .el-input__inner {
            height: 28px;
          }
        }
      }
      .tips {
        font-size: 12px;
        color: #999;
        p {
          margin: 0;
        }
      }
    }
    .transfer-proof {
      background: #fff;
      padding: 16px;
      border-radius: 0 0 8px 8px;
      margin-bottom: 20px;
      h3 {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
        color: #333;
      }
    }
    .submit-btn {
      text-align: center;
      .el-button {
        width: 200px;
      }
    }
  }
}
</style>